"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var ReviewCarousel_1 = require("../components/ReviewCarousel/ReviewCarousel");
var targetNode = document.querySelector('.review-carousel-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(ReviewCarousel_1.default, null), targetNode);
}
